var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2599 0.625H3.73852C1.67338 0.625 0 2.29925 0 4.36511V24.635C0 26.7008 1.67338 28.375 3.73852 28.375H33.2599C35.325 28.375 37 26.7008 37 24.6349V4.36511C37 2.29918 35.325 0.625 33.2599 0.625ZM20.3232 13.8416C19.2857 14.7842 17.7135 14.7842 16.6827 13.8477L5.39037 3.70836H31.6086L20.3232 13.8416ZM3.08336 5.78072L10.6759 12.5981L3.08336 22.7216V5.78072ZM12.9791 14.6661L14.6159 16.1358C16.8159 18.1347 20.1832 18.1347 22.3899 16.1297L24.02 14.6661L31.9891 25.2916H5.00996L12.9791 14.6661ZM26.3231 12.5981L33.9166 5.77985V22.7228L26.3231 12.5981Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.ecf3dc995140a44300f24dd9efc2997f.svg";
export { ForwardRef as ReactComponent };